import AppDropdown from "@/components/AppDropdown.vue";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup.vue";
import AppDropdownItem from "@/components/AppDropdownItem.vue";
import { EVENTS } from "../utils";
import { PERIOD_OPTIONS_LEFT_RIGHT_EVENTS } from "../utils/constants";
import AppIcon from "@/components/AppIcon.vue";
import WrapWithOnlyButton from "@/components/new-filters/items/WrapWithOnlyButton.vue";
import AppPopover from "@/components/AppPopover";
export default {
  name: "LTVPeriodControllers",
  components: {
    AppDropdown,
    AppButtonRadioGroup,
    AppIcon,
    WrapWithOnlyButton,
    AppDropdownItem,
    AppPopover
  },
  props: {
    ltv: Object,
    ltvSelectorOptions: Array,
    ltvOffset: Object,
    ltvOffsetOptions: Array
  },
  data() {
    return {
      hoveringOption: "",
      ltvOptionTooltips: {
        ltv_revenue_excl_vat: "Cumulative revenue per customer in this cohort, from their first order up to the selected month.",
        repeat_ltv_revenue_excl_vat: "Cumulative revenue from repeat orders only — excluding the first purchase. Shows the value generated after acquisition.",
        repeat_aov_revenue_excl_vat_cum: "Average order value of repeat purchases (all orders after the first). A higher value may indicate upsell or product mix shifts over time",
        repurchase_rate_cum: "Share of customers in this cohort who placed at least one order after their first purchase, by the selected month.",
        repurchase_frequency_cum: "Average number of repeat orders placed by customers who repurchased. Does not include customers who only bought once."
      }
    };
  },
  computed: {
    currentLTV: {
      get() {
        return this.ltv;
      },
      set(value) {
        this.$emit("update:ltv", value);
      }
    },
    currentLTVOffset: {
      get() {
        return this.ltvOffset;
      },
      set(value) {
        this.$emit("update:ltvOffset", value);
      }
    },
    displayedLTVSelector() {
      return this.ltvSelectorOptions.filter(option => option.value == this.currentLTV)[0].text;
    },
    computeShowButton() {
      return option => {
        return !this.ltvOffset.includes(option.value) && this.hoveringOption == option.value;
      };
    },
    selectedLTVOffsetLabel() {
      const selected = this.ltvOffsetOptions.filter(o => this.currentLTVOffset.includes(o.value)).map(o => o.text);
      return selected.join(", ");
    }
  },
  methods: {
    selectOnly(option) {
      this.currentLTVOffset = [option.value];
    },
    hoveringLTVOffset(option) {
      this.hoveringOption = option.value;
    }
  }
};